import { render, staticRenderFns } from "./h1-safety-banner.vue?vue&type=template&id=7b118c03&scoped=true&"
import script from "./h1-safety-banner.vue?vue&type=script&lang=js&"
export * from "./h1-safety-banner.vue?vue&type=script&lang=js&"
import style0 from "./h1-safety-banner.vue?vue&type=style&index=0&id=7b118c03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b118c03",
  null
  
)

export default component.exports